export default __webpack_public_path__ + "static/media/PyraGon.1cfbffd1.png";